(function () {
  var APP_PROXY_BASE = '/apps/ladybae-vendor-test';
  var LIST_PATH = APP_PROXY_BASE + '/customer-tickets/list';
  var FETCH_LIMIT = 200;
  var CAL_DEFAULT_KEYS = { usable: 1, pending_vendor: 1 };

  var config = { loggedIn: false, loginUrl: '/account/login', returnPath: '/pages/我的活動票券-v2' };
  var S = {
    items: [],
    filter: 'all',
    sort: 'status_then_time',
    dayFilter: null,
    calShowAll: false,
    calCursor: null,
  };
  var modalOpen = false;
  var remindModalOpen = false;
  var eventsBound = false;
  var ACK_KEY = 'lb_ticket_remind_ack_v1';
  var tomorrowRemindTickets = [];
  var tomorrowBatchKey = '';
  try {
    localStorage.removeItem('lb_ticket_remind_demo');
    sessionStorage.removeItem('lb_ticket_remind_demo');
  } catch (eDemoClear) { /* ignore */ }

  try {
    var configEl = document.getElementById('lb-my-tickets-v2-config');
    if (configEl) config = JSON.parse(configEl.textContent || '{}');
  } catch (e) {
    config = { loggedIn: false, loginUrl: '/account/login' };
  }

  var root = document.getElementById('lb-my-tickets-v2-root');
  if (!root) return;

  /* 對抗 section／page 快取：強制掛 -t2.css + 關鍵覆寫。
     檔名要跟 section 的 link 一致，否則會連舊 -t.css 一起抓（字級沒進 token 的那份）。 */
  (function ensureTicketsChromeCss() {
    var hasT = !!document.querySelector('link[href*="lb-my-tickets-v2-t2.css"]');
    if (!hasT) {
      var base = '';
      var links = document.querySelectorAll('link[href*="lb-my-tickets-v2"]');
      if (links.length) {
        base = String(links[0].getAttribute('href') || '').replace(/lb-my-tickets-v2[^/?]*/, 'lb-my-tickets-v2-t2.css');
      }
      if (!base) base = '/cdn/shop/t/13/assets/lb-my-tickets-v2-t2.css';
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'v=type1';
      document.head.appendChild(l);
    }
    if (document.getElementById('lbmt-v2-critical')) return;
    var s = document.createElement('style');
    s.id = 'lbmt-v2-critical';
    s.textContent = [
      '#lb-my-tickets-v2-root .lbmt-v2-toolbar{display:flex!important;flex-direction:column!important;gap:12px!important;align-items:stretch!important}',
      '#lb-my-tickets-v2-root .lbmt-v2-chips{display:flex!important;flex-direction:row!important;flex-wrap:wrap!important;gap:8px!important;width:100%!important}',
      '#lb-my-tickets-v2-root .lbmt-v2-chip{display:inline-flex!important;flex:0 0 auto!important;width:auto!important;align-items:center!important;min-height:34px!important;padding:7px 14px!important;border:1px solid rgba(161,63,89,.35)!important;border-radius:999px!important;background:#fff!important;color:#8f3650!important;font-style:normal!important;font-weight:500!important;cursor:pointer!important}',
      '#lb-my-tickets-v2-root .lbmt-v2-chip.is-active{background:#a13f59!important;border-color:#a13f59!important;color:#fff!important;font-weight:600!important}',
      '#lb-my-tickets-v2-root .lbmt-v2-grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:12px!important}',
      '#lb-my-tickets-v2-root .lbmt-v2-sort{width:100%!important}',
      '#lb-my-tickets-v2-root .lbmt-v2-cal{display:block!important;margin:16px 0 4px!important}',
      '#lb-my-tickets-v2-root .lbmt-v2-cal[hidden]{display:none!important}',
      '#lb-my-tickets-v2-root .lbmt-v2-cal-grid{display:grid!important;grid-template-columns:repeat(7,minmax(0,1fr))!important;gap:4px!important}',
      '@media (max-width:720px){#lb-my-tickets-v2-root .lbmt-v2-grid{grid-template-columns:1fr!important;gap:12px!important}}',
      '#lb-my-tickets-v2-root .lbmt-v2-state[hidden],#lb-my-tickets-v2-error[hidden],#lb-my-tickets-v2-loading[hidden],#lb-my-tickets-v2-login[hidden],#lb-my-tickets-v2-app[hidden]{display:none!important}',
      '#lb-my-tickets-v2-retry{display:none!important}'
    ].join('');
    document.head.appendChild(s);
  })();

  function $(id) { return document.getElementById(id); }

  var els = {
    login: $('lb-my-tickets-v2-login'),
    loginLink: $('lb-my-tickets-v2-login-link'),
    loading: $('lb-my-tickets-v2-loading'),
    error: $('lb-my-tickets-v2-error'),
    errorMsg: $('lb-my-tickets-v2-error-msg'),
    app: $('lb-my-tickets-v2-app'),
    state: $('lb-my-tickets-v2-state'),
    chips: $('lb-my-tickets-v2-filters'),
    sort: $('lb-my-tickets-v2-sort'),
    grid: $('lb-my-tickets-v2-list'),
    cal: $('lb-my-tickets-v2-cal'),
    calMonth: $('lb-my-tickets-v2-cal-month'),
    calGrid: $('lb-my-tickets-v2-cal-grid'),
    calAll: $('lb-my-tickets-v2-cal-all'),
    calClear: $('lb-my-tickets-v2-cal-clear'),
    modal: $('lb-my-tickets-v2-modal'),
    mClose: $('lb-my-tickets-v2-m-close'),
    mTitle: $('lb-my-tickets-v2-m-title'),
    mQr: $('lb-my-tickets-v2-m-qr'),
    mCode: $('lb-my-tickets-v2-m-code'),
    remindBanner: $('lb-my-tickets-v2-remind-banner'),
    remindModal: $('lb-my-tickets-v2-remind-modal'),
    remindClose: $('lb-my-tickets-v2-remind-close'),
    remindList: $('lb-my-tickets-v2-remind-list'),
    head: root.querySelector('.lbmt-v2-head'),
  };

  function esc(s) {
    s = s == null ? '' : String(s);
    return s.replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }

  // esc() 只跳脫 HTML 字元，擋不住協定：javascript:alert(1) 通過 esc 之後仍是可執行
  // 的 href。任何要放進 href 的後端字串都必須先過這裡。
  function safeUrl(s) {
    if (s == null) return '';
    var raw = String(s).trim();
    if (!raw) return '';
    try {
      var proto = new URL(raw, window.location.origin).protocol;
      return proto === 'http:' || proto === 'https:' ? raw : '';
    } catch (e) {
      return '';
    }
  }

  function parseDate(v) {
    if (!v) return null;
    var d = new Date(String(v));
    return Number.isNaN(d.getTime()) ? null : d;
  }

  function fmtTPE(v) {
    var d = parseDate(v);
    if (!d) return esc(v || '');
    var parts = new Intl.DateTimeFormat('zh-TW', {
      timeZone: 'Asia/Taipei',
      year: 'numeric', month: '2-digit', day: '2-digit',
      weekday: 'short',
      hour: '2-digit', minute: '2-digit',
      hour12: false,
    }).formatToParts(d);
    var m = {};
    parts.forEach(function (p) { m[p.type] = p.value; });
    return m.year + '/' + m.month + '/' + m.day + '（' + m.weekday + '）' + m.hour + ':' + m.minute;
  }

  function ymdTPE(dateObj) {
    var d = dateObj instanceof Date ? dateObj : new Date(dateObj);
    if (Number.isNaN(d.getTime())) return '';
    var parts = new Intl.DateTimeFormat('zh-TW', {
      timeZone: 'Asia/Taipei',
      year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(d);
    var m = {};
    parts.forEach(function (p) { m[p.type] = p.value; });
    return (m.year || '') + '-' + (m.month || '') + '-' + (m.day || '');
  }

  function fmtDayShort(ymd) {
    if (!ymd || ymd.length < 10) return ymd || '';
    return ymd.slice(5, 7) + '/' + ymd.slice(8, 10);
  }

  function pad2(n) {
    n = Number(n) || 0;
    return (n < 10 ? '0' : '') + n;
  }

  function addYmd(ymd, delta) {
    if (!ymd || ymd.length < 10) return '';
    var y = Number(ymd.slice(0, 4));
    var mo = Number(ymd.slice(5, 7));
    var day = Number(ymd.slice(8, 10));
    if (!y || !mo || !day) return '';
    var utc = Date.UTC(y, mo - 1, day + (Number(delta) || 0));
    var x = new Date(utc);
    return x.getUTCFullYear() + '-' + pad2(x.getUTCMonth() + 1) + '-' + pad2(x.getUTCDate());
  }

  function monthStart(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1);
  }

  function ticketUid(t) {
    return String((t && (t.ticket_uid || t.qr_payload)) || '').trim();
  }

  function isRemindableTicket(t) {
    var st = getStatus(t).key;
    return st === 'usable' || st === 'pending_vendor';
  }

  /** 與 header v4 isUsableTicket 一致（今日 badge 張數） */
  function isUsableTicketForBadge(t) {
    var label = String(t.state_label || '').trim();
    var raw = String(t.state || t.ticket_status || t.status || '').toUpperCase();
    var awaits =
      t.awaits_vendor_payment_confirm === true ||
      raw === 'PENDING_VENDOR_CONFIRM' ||
      String(t.state || '').toLowerCase() === 'pending_vendor';

    if (t.redeemed || t.redeemed_at || /已使用/.test(label)) return false;
    if (raw === 'VOID' || raw === 'VOIDED' || raw === 'CANCELLED' || raw === 'REFUNDED' || /取消|作廢|VOID|已取消/.test(label)) {
      return false;
    }
    if (awaits || /待廠商確認|待確認收款/.test(label)) return false;
    if (raw === 'EXPIRED' || String(t.state || '').toLowerCase() === 'expired' || /已過期/.test(label)) {
      return false;
    }
    var end = parseDate(t.event_end_at || t.end_at) || parseDate(t.event_start_at || t.start_at);
    if (end && end.getTime() < Date.now()) return false;
    if (t.qr_usable === false) return false;
    return true;
  }

  function readRemindAck() {
    try {
      var raw = localStorage.getItem(ACK_KEY);
      if (!raw) return null;
      var j = JSON.parse(raw);
      return j && typeof j === 'object' ? j : null;
    } catch (e) {
      return null;
    }
  }

  function writeRemindAck(batchKey) {
    try {
      localStorage.setItem(ACK_KEY, JSON.stringify({
        batchKey: batchKey,
        ackedAt: new Date().toISOString(),
      }));
    } catch (e) { /* ignore */ }
  }

  function isRemindBatchAcked(batchKey) {
    if (!batchKey) return false;
    var ack = readRemindAck();
    return !!(ack && ack.batchKey === batchKey);
  }

  function buildRemindBatchKey(tomorrowYmd, tickets) {
    var uids = tickets.map(ticketUid).filter(Boolean).sort();
    return tomorrowYmd + '|' + uids.join(',');
  }

  function collectTomorrowRemindTickets(items) {
    var tomorrow = addYmd(ymdTPE(new Date()), 1);
    var list = [];
    (items || []).forEach(function (t) {
      if (ticketYmd(t) === tomorrow && isRemindableTicket(t)) list.push(t);
    });
    list.sort(function (a, b) { return getStartMs(a) - getStartMs(b); });
    return { tomorrowYmd: tomorrow, tickets: list, batchKey: list.length ? buildRemindBatchKey(tomorrow, list) : '' };
  }

  function queryParam(name) {
    try {
      return String(new URL(window.location.href).searchParams.get(name) || '');
    } catch (e) {
      return '';
    }
  }

  function clearQueryParam(name) {
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has(name)) return;
      u.searchParams.delete(name);
      window.history.replaceState({}, '', u.toString());
    } catch (e) { /* ignore */ }
  }

  function ensureRemindBanner() {
    if (els.remindBanner) return els.remindBanner;
    if (!els.head) return null;
    var el = document.createElement('div');
    el.id = 'lb-my-tickets-v2-remind-banner';
    el.className = 'lbmt-v2-remind-banner';
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.hidden = true;
    els.head.insertBefore(el, els.head.firstChild);
    els.remindBanner = el;
    return el;
  }

  function updateRemindBanner() {
    var banner = ensureRemindBanner();
    if (!banner) return;
    var n = tomorrowRemindTickets.length;
    if (!n) {
      banner.hidden = true;
      banner.textContent = '';
      return;
    }
    banner.hidden = false;
    banner.textContent = '明天有 ' + n + ' 堂課｜點此查看';
  }

  function ensureRemindModalPortal() {
    if (!els.remindModal || els.remindModal.parentNode === document.body) return;
    document.body.appendChild(els.remindModal);
  }

  function openRemindModal(markAck) {
    if (!els.remindModal || !tomorrowRemindTickets.length) return;
    ensureRemindModalPortal();
    if (els.remindList) {
      els.remindList.innerHTML = tomorrowRemindTickets.map(function (t) {
        var uid = ticketUid(t);
        var title = esc(t.event_title || '(未命名活動)');
        var when = fmtTPE(t.event_start_at || t.start_at || '');
        return (
          '<button type="button" class="lbmt-v2-remind-item" data-remind-uid="' + esc(uid) + '">' +
            '<span class="lbmt-v2-remind-item-title">' + title + '</span>' +
            '<span class="lbmt-v2-remind-item-meta">' + when + '</span>' +
          '</button>'
        );
      }).join('');
    }
    remindModalOpen = true;
    els.remindModal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lbmt-v2-modal-open');
    document.body.classList.add('lbmt-v2-modal-open');
    if (markAck && tomorrowBatchKey) {
      writeRemindAck(tomorrowBatchKey);
      refreshHeaderBadgeAfterAck();
    }
    clearQueryParam('lb_remind');
  }

  function refreshHeaderBadgeAfterAck() {
    var badge = document.querySelector('#nav-user [data-lb-tickets-count]');
    var link = document.querySelector('#nav-user a.lb-header-my-tickets-icon');
    if (!badge) return;
    var today = ymdTPE(new Date());
    var n = 0;
    (S.items || []).forEach(function (t) {
      if (ticketYmd(t) !== today) return;
      if (!isUsableTicketForBadge(t)) return;
      n += 1;
    });
    badge.textContent = n > 99 ? '99+' : String(n);
    badge.classList.remove('is-remind');
    badge.removeAttribute('hidden');
    badge.setAttribute('data-count', String(n));
    if (link) {
      link.href = '/pages/我的活動票券-v2';
      link.setAttribute('aria-label', '我的票券，今日未使用 ' + n + ' 張');
    }
  }

  function closeRemindModal() {
    if (!els.remindModal) return;
    remindModalOpen = false;
    els.remindModal.setAttribute('aria-hidden', 'true');
    if (!modalOpen) {
      document.documentElement.classList.remove('lbmt-v2-modal-open');
      document.body.classList.remove('lbmt-v2-modal-open');
    }
    if (els.remindList) els.remindList.innerHTML = '';
  }

  function focusTicketByUid(uid) {
    uid = String(uid || '').trim();
    if (!uid) return;
    S.dayFilter = null;
    S.filter = 'all';
    apply();
    var card = els.grid ? els.grid.querySelector('[data-uid="' + uid.replace(/"/g, '\\"') + '"]') : null;
    if (!card) {
      /* attribute selector escape: query via scan */
      var cards = els.grid ? els.grid.querySelectorAll('[data-card="1"]') : [];
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getAttribute('data-uid') === uid) {
          card = cards[i];
          break;
        }
      }
    }
    if (!card) return;
    try {
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      card.scrollIntoView(true);
    }
    card.classList.add('is-remind-focus');
    window.setTimeout(function () {
      card.classList.remove('is-remind-focus');
    }, 2600);
  }

  function getStatus(t) {
    var label = String(t.state_label || '').trim();
    var raw = String(t.state || t.ticket_status || t.status || '').toUpperCase();
    var awaits = t.awaits_vendor_payment_confirm === true ||
      raw === 'PENDING_VENDOR_CONFIRM' ||
      String(t.state || '').toLowerCase() === 'pending_vendor';

    if (t.redeemed || t.redeemed_at || /已使用/.test(label)) {
      return { key: 'used', label: label || '已使用' };
    }
    if (raw === 'VOID' || raw === 'VOIDED' || raw === 'CANCELLED' || raw === 'REFUNDED' || /取消|作廢|VOID|已取消/.test(label)) {
      return { key: 'void', label: label || '已取消' };
    }
    /* 未核銷 + 活動時間已過 → 已過期（以後端 state 為準，前端時間再兜底） */
    if (raw === 'EXPIRED' || String(t.state || '').toLowerCase() === 'expired' || /已過期/.test(label)) {
      return { key: 'expired', label: label || '已過期' };
    }
    var end = parseDate(t.event_end_at || t.end_at) || parseDate(t.event_start_at || t.start_at);
    if (end && end.getTime() < Date.now()) {
      return { key: 'expired', label: '已過期' };
    }
    if (awaits || /待廠商確認|待確認收款/.test(label)) {
      return { key: 'pending_vendor', label: label || '待廠商確認收款' };
    }
    return { key: 'usable', label: label || '可使用' };
  }

  function getStartMs(t) {
    var d = parseDate(t.event_start_at || t.start_at);
    return d ? d.getTime() : 0;
  }

  function ticketYmd(t) {
    var start = parseDate(t.event_start_at || t.start_at);
    return start ? ymdTPE(start) : '';
  }

  function isCalVisibleStatus(key) {
    if (S.calShowAll) return true;
    return !!CAL_DEFAULT_KEYS[key];
  }

  function isTodayUnredeemed(t) {
    if (getStatus(t).key !== 'usable') return false;
    var start = parseDate(t.event_start_at || t.start_at);
    if (!start) return false;
    var end = parseDate(t.event_end_at || t.end_at) || start;
    var today = ymdTPE(new Date());
    var s = ymdTPE(start);
    var e = ymdTPE(end);
    return !!(today && s && e && today >= s && today <= e);
  }

  function getQrFactory() {
    if (typeof window.qrcode === 'function') return window.qrcode;
    if (typeof qrcode === 'function') return qrcode;
    return null;
  }

  function qrImgHtml(uid, cellSize) {
    if (!uid) return '';
    var factory = getQrFactory();
    if (!factory) return '';
    try {
      var qr = factory(0, 'M');
      qr.addData(String(uid));
      qr.make();
      return qr.createImgTag(cellSize || 5, 4);
    } catch (e) {
      return '';
    }
  }

  function dotColor(key) {
    if (key === 'usable') return 'rgba(34,197,94,.75)';
    if (key === 'pending_vendor') return 'rgba(234,179,8,.9)';
    if (key === 'used') return 'rgba(59,130,246,.65)';
    if (key === 'void') return 'rgba(239,68,68,.70)';
    if (key === 'expired') return 'rgba(245,158,11,.75)';
    if (key === 'today_unredeemed') return 'rgba(161,63,89,.95)';
    return 'rgba(31,20,24,.18)';
  }

  function filterLabel(key) {
    if (key === 'today_unredeemed') return '今日未使用';
    if (key === 'usable') return '可使用';
    if (key === 'pending_vendor') return '待確認收款';
    if (key === 'used') return '已使用';
    if (key === 'void') return '已取消';
    if (key === 'expired') return '已過期';
    return '';
  }

  function buildCounts(items) {
    var counts = { all: items.length, today_unredeemed: 0, usable: 0, pending_vendor: 0, used: 0, void: 0, expired: 0 };
    items.forEach(function (t) {
      var k = getStatus(t).key;
      if (counts[k] != null) counts[k] += 1;
      if (isTodayUnredeemed(t)) counts.today_unredeemed += 1;
    });
    return counts;
  }

  function buildChips(counts) {
    if (!els.chips) return;
    var defs = [
      { key: 'all', label: '全部' },
      { key: 'today_unredeemed', label: '今日未使用' },
      { key: 'usable', label: '可使用' },
      { key: 'pending_vendor', label: '待確認收款' },
      { key: 'used', label: '已使用' },
      { key: 'void', label: '已取消' },
      { key: 'expired', label: '已過期' },
    ];
    els.chips.innerHTML = defs.map(function (d) {
      var n = d.key === 'all' ? (counts.all || 0) : (counts[d.key] || 0);
      var active = S.filter === d.key ? 'is-active' : '';
      /* 用 span，避開主題全域 button 粉紅／寬度 100% */
      return (
        '<span class="lbmt-v2-chip ' + active + '" role="button" tabindex="0" data-filter="' + d.key + '">' +
          '<i class="lbmt-v2-dot" style="background:' + dotColor(d.key) + '" aria-hidden="true"></i>' +
          '<em class="lbmt-v2-chip-label">' + d.label + '（' + n + '）</em>' +
        '</span>'
      );
    }).join('');
  }

  function ticketsForCal(items) {
    var byDay = {};
    items.forEach(function (t) {
      var key = getStatus(t).key;
      if (!isCalVisibleStatus(key)) return;
      var ymd = ticketYmd(t);
      if (!ymd) return;
      if (!byDay[ymd]) byDay[ymd] = { count: 0, keys: {} };
      byDay[ymd].count += 1;
      byDay[ymd].keys[key] = (byDay[ymd].keys[key] || 0) + 1;
    });
    return byDay;
  }

  function pickInitialCalCursor(items) {
    var today = ymdTPE(new Date());
    var hasToday = items.some(function (t) { return ticketYmd(t) === today; });
    if (hasToday) return monthStart(new Date());

    var now = Date.now();
    var best = null;
    items.forEach(function (t) {
      var key = getStatus(t).key;
      if (!CAL_DEFAULT_KEYS[key]) return;
      var start = parseDate(t.event_start_at || t.start_at);
      if (!start || start.getTime() < now) return;
      if (!best || start.getTime() < best.getTime()) best = start;
    });
    return monthStart(best || new Date());
  }

  function renderCal() {
    if (!els.cal || !els.calGrid) return;
    if (!S.calCursor) S.calCursor = monthStart(new Date());

    els.cal.hidden = false;
    els.cal.removeAttribute('hidden');
    els.cal.style.display = '';

    var y = S.calCursor.getFullYear();
    var m = S.calCursor.getMonth();
    if (els.calMonth) {
      els.calMonth.textContent = y + ' 年 ' + String(m + 1).padStart(2, '0') + ' 月';
    }

    if (els.calClear) {
      var showClear = !!S.dayFilter;
      els.calClear.hidden = !showClear;
      if (showClear) els.calClear.removeAttribute('hidden');
      else els.calClear.setAttribute('hidden', '');
      els.calClear.style.display = showClear ? '' : 'none';
    }

    if (els.calAll) els.calAll.checked = !!S.calShowAll;

    var byDay = ticketsForCal(S.items);
    var todayYmd = ymdTPE(new Date());
    var first = new Date(y, m, 1);
    var startPad = (first.getDay() + 6) % 7; /* Mon=0 */
    var daysInMonth = new Date(y, m + 1, 0).getDate();
    var dow = ['一', '二', '三', '四', '五', '六', '日'];
    var html = '';
    dow.forEach(function (d) {
      html += '<div class="lbmt-v2-cal-dow" aria-hidden="true">' + d + '</div>';
    });

    for (var i = 0; i < startPad; i++) {
      html += '<div class="lbmt-v2-cal-cell lbmt-v2-cal-cell--pad" aria-hidden="true"></div>';
    }

    for (var day = 1; day <= daysInMonth; day++) {
      var ymd = y + '-' + pad2(m + 1) + '-' + pad2(day);
      var bucket = byDay[ymd];
      var count = bucket ? bucket.count : 0;
      var has = count > 0;
      var isToday = ymd === todayYmd;
      var isSel = S.dayFilter === ymd;
      var cls = 'lbmt-v2-cal-cell';
      if (has) cls += ' lbmt-v2-cal-cell--has';
      if (isToday) cls += ' is-today';
      if (isSel) cls += ' is-selected';
      var role = has ? ' role="button" tabindex="0"' : '';
      var data = has ? ' data-cal-day="' + ymd + '"' : '';
      var dots = '';
      if (bucket) {
        var order = ['usable', 'pending_vendor', 'used', 'void', 'expired'];
        var shown = 0;
        for (var oi = 0; oi < order.length && shown < 3; oi++) {
          if (!bucket.keys[order[oi]]) continue;
          dots += '<i class="lbmt-v2-cal-dot lbmt-v2-cal-dot--' + order[oi] + '" style="background:' + dotColor(order[oi]) + '" aria-hidden="true"></i>';
          shown += 1;
        }
      }
      var countHtml = has
        ? '<span class="lbmt-v2-cal-count">' + count + '</span>'
        : '';
      var aria = has
        ? ' aria-label="' + esc(ymd + '，' + count + ' 張票券') + (isSel ? '，已選取' : '') + '"'
        : '';
      html +=
        '<div class="' + cls + '"' + role + data + aria + '>' +
          '<span class="lbmt-v2-cal-daynum">' + day + '</span>' +
          '<span class="lbmt-v2-cal-marks">' + dots + countHtml + '</span>' +
        '</div>';
    }

    els.calGrid.innerHTML = html;
  }

  function renderCard(t) {
    var st = getStatus(t);
    var title = esc(t.event_title || '(未命名活動)');
    var start = t.event_start_at || t.start_at || '';
    var end = t.event_end_at || t.end_at || '';
    var when = (start ? fmtTPE(start) : '') + (end ? (' ～ ' + fmtTPE(end)) : '');
    var venue = esc(t.venue_name || '');
    var addr = esc(t.address || '');
    var type = esc(t.ticket_type || t.variant_title || t.product_title || '');
    var uidRaw = t.ticket_uid || t.qr_payload || '';
    var uid = esc(uidRaw);
    var qrUsable = t.qr_usable !== false && st.key === 'usable';
    var qr = qrUsable ? qrImgHtml(uidRaw, 4) : '';
    function metaRow(k, v) {
      if (!v) return '';
      return (
        '<div class="lbmt-v2-meta-row">' +
          '<span class="lbmt-v2-meta-k">' + k + '</span>' +
          '<span class="lbmt-v2-meta-v">' + v + '</span>' +
        '</div>'
      );
    }

    var mapsHref = safeUrl(t.maps_url);
    var maps = mapsHref
      ? '<a class="lbmt-v2-link" data-nomodal="1" href="' + esc(mapsHref) + '" target="_blank" rel="noopener">查看地圖</a>'
      : '';
    var hint = t.status_hint
      ? '<div class="lbmt-v2-status-hint">' + esc(t.status_hint) + '</div>'
      : (st.key === 'pending_vendor'
        ? '<div class="lbmt-v2-status-hint">此為純上架活動：LadyBae $0 僅為報名登記。請向廠商完成付款與發票；廠商確認收款後，報名 QR 才會啟用。</div>'
        : '');

    var payUrl = String(t.external_purchase_url || '').trim();
    var payBtn =
      st.key === 'pending_vendor' && payUrl
        ? '<a class="lbmt-v2-btn lbmt-v2-btn--pay" data-nomodal="1" href="' + esc(payUrl) + '" target="_blank" rel="noopener">前往廠商付款</a>'
        : '';

    return (
      '<div class="lbmt-v2-ticket lbmt-v2-ticket--' + st.key + '" data-card="1" data-uid="' + uid + '" data-title="' + title.replace(/"/g, '&quot;') + '" data-qr-usable="' + (qrUsable ? '1' : '0') + '">' +
        '<div class="lbmt-v2-ticket-top">' +
          '<h3 class="lbmt-v2-ticket-title">' + title + '</h3>' +
          '<span class="lbmt-v2-badge lbmt-v2-badge--' + st.key + '">' + esc(st.label) + '</span>' +
        '</div>' +
        '<div class="lbmt-v2-meta">' +
          metaRow('時間', when) +
          metaRow('地點', venue) +
          metaRow('地址', addr ? addr + (maps ? ' · ' + maps : '') : '') +
          metaRow('票種', type) +
          (!addr && maps ? '<div class="lbmt-v2-meta-row"><span class="lbmt-v2-meta-k"></span><span class="lbmt-v2-meta-v">' + maps + '</span></div>' : '') +
          hint +
        '</div>' +
        '<div class="lbmt-v2-qr-row">' +
          '<div class="lbmt-v2-qr-left">' +
            (qrUsable && uidRaw && qr ? '<span data-qr-host="1">' + qr + '</span>' : '') +
            (!qrUsable && st.key === 'pending_vendor'
              ? '<div class="lbmt-v2-qr-locked">報名 QR 尚未啟用<br><span class="lbmt-v2-code">請完成廠商付款並等候確認</span></div>'
              : '') +
            '<div>' +
              '<div class="lbmt-v2-code">票券代碼<br>' + uid + '</div>' +
              (t.redeemed ? '<div class="lbmt-v2-code">已使用：' + (t.redeemed_at ? fmtTPE(t.redeemed_at) : '') + '</div>' : '') +
            '</div>' +
          '</div>' +
          '<div class="lbmt-v2-action">' +
            payBtn +
            (qrUsable && uidRaw ? '<button class="lbmt-v2-btn" type="button" data-open-qr="1" data-uid="' + uid + '" data-title="' + title.replace(/"/g, '&quot;') + '">放大 QR</button>' : '') +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function apply() {
    var list = S.items.slice();

    if (S.filter !== 'all') {
      list = list.filter(function (t) {
        if (S.filter === 'today_unredeemed') return isTodayUnredeemed(t);
        return getStatus(t).key === S.filter;
      });
    }

    if (S.dayFilter) {
      list = list.filter(function (t) {
        return ticketYmd(t) === S.dayFilter;
      });
    }

    if (S.sort === 'start_asc') {
      list.sort(function (a, b) { return getStartMs(a) - getStartMs(b); });
    } else if (S.sort === 'start_desc') {
      list.sort(function (a, b) { return getStartMs(b) - getStartMs(a); });
    } else if (S.sort === 'status_then_time') {
      var rank = { usable: 0, pending_vendor: 1, expired: 2, used: 3, void: 4 };
      list.sort(function (a, b) {
        var ra = rank[getStatus(a).key] != null ? rank[getStatus(a).key] : 9;
        var rb = rank[getStatus(b).key] != null ? rank[getStatus(b).key] : 9;
        if (ra !== rb) return ra - rb;
        return getStartMs(a) - getStartMs(b);
      });
    }

    if (els.grid) {
      els.grid.innerHTML = list.map(renderCard).join('');
      Array.prototype.forEach.call(els.grid.querySelectorAll('[data-qr-host] img'), function (img) {
        img.addEventListener('error', function () { img.style.display = 'none'; });
      });
    }

    var total = S.items.length;
    var showing = list.length;
    if (els.state) {
      if (S.filter === 'all' && S.dayFilter) {
        els.state.textContent = '共 ' + total + ' 張票券｜' + fmtDayShort(S.dayFilter) + ' 顯示 ' + showing + ' 張';
      } else if (S.filter !== 'all' && S.dayFilter) {
        els.state.textContent = '共 ' + total + ' 張票券｜' + filterLabel(S.filter) + '｜' + fmtDayShort(S.dayFilter) + ' 顯示 ' + showing + ' 張';
      } else if (S.filter !== 'all') {
        els.state.textContent = '共 ' + total + ' 張票券｜' + filterLabel(S.filter) + ' 顯示 ' + showing + ' 張';
      } else {
        els.state.textContent = '共 ' + total + ' 張票券';
      }
    }

    buildChips(buildCounts(S.items));
    renderCal();
  }

  function setDayFilter(ymd) {
    if (!ymd) {
      S.dayFilter = null;
    } else if (S.dayFilter === ymd) {
      S.dayFilter = null;
    } else {
      S.dayFilter = ymd;
    }
    apply();
  }

  /** 跳到當月；若今日有票（依月曆可見狀態）則順便篩今日 */
  function goToday() {
    var today = ymdTPE(new Date());
    S.calCursor = monthStart(new Date());
    var byDay = ticketsForCal(S.items);
    if (byDay[today] && byDay[today].count > 0) {
      S.dayFilter = today;
    }
    apply();
  }

  function ensureModalPortal() {
    if (!els.modal || els.modal.parentNode === document.body) return;
    document.body.appendChild(els.modal);
  }

  function openModal(uid, title) {
    if (!els.modal || !uid) return;
    ensureModalPortal();
    modalOpen = true;
    if (els.mTitle) {
      els.mTitle.textContent = title ? ('票券 QR code｜' + title) : '票券 QR code';
    }
    if (els.mQr) {
      els.mQr.innerHTML = qrImgHtml(uid, 8) || '<span class="lbmt-v2-code">無法產生 QR Code</span>';
      var img = els.mQr.querySelector('img');
      if (img) {
        img.alt = 'QR code';
        img.className = '';
      }
    }
    if (els.mCode) els.mCode.textContent = uid ? ('票券代碼：' + uid) : '';
    els.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lbmt-v2-modal-open');
    document.body.classList.add('lbmt-v2-modal-open');
  }

  function closeModal() {
    if (!els.modal) return;
    modalOpen = false;
    els.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lbmt-v2-modal-open');
    document.body.classList.remove('lbmt-v2-modal-open');
    if (els.mQr) els.mQr.innerHTML = '';
    if (els.mCode) els.mCode.textContent = '';
  }

  function onCloseModalClick(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    closeModal();
  }

  function showOnly(target) {
    [els.login, els.loading, els.error, els.app].forEach(function (el) {
      if (!el) return;
      var on = el === target;
      el.hidden = !on;
      if (on) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
      /* 避免主題／自訂 CSS 的 display:flex 蓋掉 [hidden] */
      el.style.display = on ? '' : 'none';
    });
    if (target !== els.error && els.errorMsg) els.errorMsg.textContent = '';
  }

  /** 拆掉主題 bv_mainselect，改用原生 select（避免顯示 Select Option） */
  function preferNativeSortSelect() {
    if (!els.sort) return;
    var sel = els.sort;
    var main = sel.closest('.bv_mainselect');
    if (main && main.parentNode) {
      main.parentNode.insertBefore(sel, main);
      main.parentNode.removeChild(main);
    }
    sel.classList.add('lbmt-v2-native-select');
    sel.value = S.sort;
    if (!sel.value) {
      sel.value = 'status_then_time';
      S.sort = 'status_then_time';
    }
    /* 同步可見文字：確保 selected 屬性在正確 option */
    Array.prototype.forEach.call(sel.options, function (opt) {
      if (opt.value === sel.value) opt.selected = true;
      else opt.selected = false;
    });
  }

  function setLoginHref() {
    if (!els.loginLink) return;
    var returnPath = config.returnPath || window.location.pathname;
    var sep = String(config.loginUrl || '').indexOf('?') >= 0 ? '&' : '?';
    els.loginLink.href = String(config.loginUrl || '/account/login') + sep + 'return_url=' + encodeURIComponent(returnPath);
  }

  async function fetchTickets() {
    var params = new URLSearchParams();
    params.set('page', '1');
    params.set('limit', String(FETCH_LIMIT));
    var response = await fetch(LIST_PATH + '?' + params.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    var payload = null;
    try { payload = await response.json(); } catch (e) { payload = null; }
    if (!response.ok || !payload || payload.ok !== true) {
      var message = payload && payload.error && payload.error.message ? payload.error.message : '載入失敗';
      throw new Error(message);
    }
    return Array.isArray(payload.data) ? payload.data : [];
  }

  function bindEvents() {
    if (els.chips) {
      function pickFilter(el) {
        if (!el) return;
        S.filter = el.getAttribute('data-filter') || 'all';
        apply();
      }
      els.chips.addEventListener('click', function (e) {
        pickFilter(e.target.closest('[data-filter]'));
      });
      els.chips.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var el = e.target.closest('[data-filter]');
        if (!el) return;
        e.preventDefault();
        pickFilter(el);
      });
    }

    if (els.sort) {
      els.sort.addEventListener('change', function () {
        S.sort = els.sort.value || 'status_then_time';
        apply();
      });
    }

    if (els.cal) {
      els.cal.addEventListener('click', function (e) {
        var prev = e.target.closest('[data-cal-prev]');
        if (prev) {
          S.calCursor = new Date(S.calCursor.getFullYear(), S.calCursor.getMonth() - 1, 1);
          renderCal();
          return;
        }
        var next = e.target.closest('[data-cal-next]');
        if (next) {
          S.calCursor = new Date(S.calCursor.getFullYear(), S.calCursor.getMonth() + 1, 1);
          renderCal();
          return;
        }
        var todayBtn = e.target.closest('[data-cal-today]');
        if (todayBtn) {
          goToday();
          return;
        }
        var clear = e.target.closest('#lb-my-tickets-v2-cal-clear');
        if (clear) {
          setDayFilter(null);
          return;
        }
        var dayEl = e.target.closest('[data-cal-day]');
        if (dayEl) {
          setDayFilter(dayEl.getAttribute('data-cal-day') || null);
        }
      });
      els.cal.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var dayEl = e.target.closest('[data-cal-day]');
        var nav = e.target.closest('[data-cal-prev],[data-cal-next],[data-cal-today],#lb-my-tickets-v2-cal-clear');
        if (!dayEl && !nav) return;
        e.preventDefault();
        if (dayEl) setDayFilter(dayEl.getAttribute('data-cal-day') || null);
        else if (e.target.closest('[data-cal-prev]')) {
          S.calCursor = new Date(S.calCursor.getFullYear(), S.calCursor.getMonth() - 1, 1);
          renderCal();
        } else if (e.target.closest('[data-cal-next]')) {
          S.calCursor = new Date(S.calCursor.getFullYear(), S.calCursor.getMonth() + 1, 1);
          renderCal();
        } else if (e.target.closest('[data-cal-today]')) {
          goToday();
        } else if (e.target.closest('#lb-my-tickets-v2-cal-clear')) {
          setDayFilter(null);
        }
      });
    }

    if (els.calAll) {
      els.calAll.addEventListener('change', function () {
        S.calShowAll = !!els.calAll.checked;
        renderCal();
      });
    }

    if (els.grid) {
      els.grid.addEventListener('click', function (e) {
        if (e.target && e.target.closest('[data-nomodal="1"]')) return;
        var btn = e.target.closest('[data-open-qr="1"]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          openModal(btn.getAttribute('data-uid') || '', btn.getAttribute('data-title') || '');
          return;
        }
        var card = e.target.closest('[data-card="1"]');
        if (card && card.getAttribute('data-qr-usable') === '1') {
          openModal(card.getAttribute('data-uid') || '', card.getAttribute('data-title') || '');
        }
      });
    }

    if (els.mClose) els.mClose.addEventListener('click', onCloseModalClick);
    if (els.modal) {
      els.modal.addEventListener('click', function (e) {
        if (e.target === els.modal) onCloseModalClick(e);
      });
    }

    var banner = ensureRemindBanner();
    if (banner) {
      function openFromBanner() {
        openRemindModal(false);
      }
      banner.addEventListener('click', openFromBanner);
      banner.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        openFromBanner();
      });
    }
    if (els.remindClose) {
      els.remindClose.addEventListener('click', function (e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        closeRemindModal();
      });
    }
    if (els.remindModal) {
      els.remindModal.addEventListener('click', function (e) {
        if (e.target === els.remindModal) closeRemindModal();
        var item = e.target.closest('[data-remind-uid]');
        if (!item) return;
        var uid = item.getAttribute('data-remind-uid') || '';
        closeRemindModal();
        focusTicketByUid(uid);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (remindModalOpen) {
        closeRemindModal();
        return;
      }
      if (modalOpen) closeModal();
    });

    /* 已在票券頁時點右上驚嘆號：直接開彈窗（不必整頁重載） */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a.lb-header-my-tickets-icon');
      if (!a) return;
      if (!tomorrowRemindTickets.length) return;
      var unread = tomorrowBatchKey && !isRemindBatchAcked(tomorrowBatchKey);
      if (!unread) return;
      e.preventDefault();
      e.stopPropagation();
      openRemindModal(true);
    }, true);
  }

  async function bootstrap() {
    ensureModalPortal();
    ensureRemindModalPortal();
    setLoginHref();
    if (!eventsBound) {
      bindEvents();
      eventsBound = true;
    }

    if (!config.loggedIn) {
      showOnly(els.login);
      return;
    }

    showOnly(els.loading);

    try {
      S.items = await fetchTickets();
      var counts = buildCounts(S.items);
      S.filter = counts.today_unredeemed > 0 ? 'today_unredeemed' : 'all';
      S.calCursor = pickInitialCalCursor(S.items);
      var remind = collectTomorrowRemindTickets(S.items);
      tomorrowRemindTickets = remind.tickets;
      tomorrowBatchKey = remind.batchKey;
      showOnly(els.app);
      preferNativeSortSelect();
      apply();
      updateRemindBanner();

      var wantRemind = queryParam('lb_remind') === '1';
      var unread = tomorrowBatchKey && !isRemindBatchAcked(tomorrowBatchKey);
      if (wantRemind && tomorrowRemindTickets.length && unread) {
        openRemindModal(true);
      } else if (wantRemind) {
        clearQueryParam('lb_remind');
      }

      var focusUid = queryParam('ticket');
      if (focusUid) {
        window.setTimeout(function () {
          focusTicketByUid(focusUid);
          clearQueryParam('ticket');
        }, 80);
      }
    } catch (err) {
      if (els.errorMsg) els.errorMsg.textContent = err && err.message ? err.message : '載入失敗';
      showOnly(els.error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
/* ticket-remind10 20260727T175000Z show-zero-balance */
